import type { AnimationDataV3 } from './types/v3';
import type { AnimationDataV4 } from './types/v4';

/**
 * V3 → V4. Pure type widening: `ContentSource` adds `'url'` and `'upload'`.
 * Every V3 blob is structurally a V4 blob — just bump the version.
 */
export function v3ToV4(input: AnimationDataV3): AnimationDataV4 {
    return { ...input, version: 4 };
}
